// Copyright (c) 2016 Deere & Company

import PartReturnSettings from './components/part-returns-settings';
import actionCreators from '../shared/action-creators';
import {connect} from 'react-redux';
import {handleOnPageLeave} from '../shared/services/handle-on-page-leave';

const getStateToBindToContainerProps = state => ({
    ...state.user.preferences,
    userPartReturnSettings: state.user.details.settings.partReturns
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps,
        handleOnPageLeave
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PartReturnSettings);



// WEBPACK FOOTER //
// ./src/user/part-returns-settings/state-connector.js